import React, { useState } from "react";
import { MultiSelect } from "react-multi-select-component";

import {
  Box
} from '@chakra-ui/react';

const options = [
  { label: "Mercado Livre (1)", value: "0" },
  { label: "Mercado Livre (2)", value: "1" },
  { label: "Mercado Livre (3)", value: "7" },
  { label: "TAGA (Venda Manual)", value: "5" },
  { label: "TAGA (Ecommerce)", value: "6" },
  { label: "Mercado Shops", value: "2" },
  { label: "Magalu", value: "3" },
  { label: "Amazon", value: "4" },
];


const nameStrings = {
  "allItemsAreSelected": "Todos Selecionados",
  "clearSearch": "Limpar pesquisa",
  "clearSelected": "Clear Selected",
  "noOptions": "Sem opções",
  "search": "Pesquisar",
  "selectAll": "Selecionar todos",
  "selectAllFiltered": "Selecionar todos",
  "selectSomeItems": "Selecione",
  "create": "Create",
}


const MultipleSelectMktplacesVendas = ({ selectedOptionsStatus, handleSelectedOptionsStatusChange, paginaVendas }) => {
  return (
    <Box >
      <MultiSelect
        className={paginaVendas == true ? "custom-multiselect" : ""}
        id="MultipleSelectMktplacesVendas"
        options={options}
        value={selectedOptionsStatus}
        onChange={handleSelectedOptionsStatusChange}
        labelledBy="Selecione..."
        overrideStrings={nameStrings}
        style={{
          position: 'relative',
          zIndex: 9999,
        }}
      />
    </Box>
  );
};

export default MultipleSelectMktplacesVendas;
